export const MESSAGE_TYPES = [
    "AUTH_REQUEST",
    "AUTH_SUCCESS",
    "AUTH_FAILED",
    "INVOICE_REQUEST",
    "INVOICE_SENT",
    "INVOICE_FAILED",
    "PAYMENT_CONFIRMED",
    "PAYMENT_FAILED",
    "CLOSE",
];
